export default __webpack_public_path__ + "static/media/69ea73c64e0929176878276fd614c409 1.095b3eef.png";